var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
    position: 'relative'
  })},[_c('div',{staticClass:"d-flex justify-center align-start align-self-start",style:({
      padding: `${_vm.$getScaledCssValue('8px')} ${_vm.$getScaledCssValue('30px')}`,
      borderRadius: _vm.$getScaledCssValue('7px'),
      border: '1px solid #DBDBDB'
    }),attrs:{"tabindex":"1"},on:{"click":function($event){_vm.menuOpen = !_vm.menuOpen}}},[_c('div',{staticClass:"text-p3"},[_vm._v(_vm._s(_vm.label))]),_c('v-icon',{attrs:{"size":20}},[_vm._v("mdi-menu-down")])],1),_c('div',{style:({
      backgroundColor: 'white',
      padding: `${_vm.$getScaledCssValue('16px')} 0 ${_vm.$getScaledCssValue(
        '16px'
      )} ${_vm.$getScaledCssValue('16px')}`,
      visibility: _vm.menuOpen ? 'visible' : 'hidden',
      opacity: _vm.menuOpen ? 1 : 0,
      position: 'absolute',
      //top:$getScaledCssValue('100% - 7px'),
      zIndex: 2,
      boxShadow: `0 ${_vm.$getScaledCssValue('3px')} ${_vm.$getScaledCssValue(
        '6px'
      )} #00000029`,
      //width: '100%'
    }),attrs:{"tabindex":"1"},on:{"blur":function($event){_vm.menuOpen = false}}},[_c('v-virtual-scroll',{style:({
        scrollbarWidth: 'none'
      }),attrs:{"items":_vm.items,"height":_vm.$getScaledValue(256),"item-height":_vm.$getScaledValue(32),"width":200},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_c('Checkbox',{staticClass:"checkbox",style:({
            height: _vm.$getScaledCssValue('32px'),
            display: 'block'
          }),attrs:{"val":item,"dense":"","color":"green"},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',{staticClass:"text-p5",style:({
                //width: $getScaledCssValue('127px'),
                width:'140px',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
              })},[_vm._v(" "+_vm._s(item)+" ")])]},proxy:true}],null,true),model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})]}}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }